export default function fromEntries<T = any>(
	entries: Iterable<readonly [PropertyKey, T]>
): { [k: string]: T } {
	return [...entries].reduce(
		(acc, [key, value]) => Object.assign(acc, { [key]: value }),
		{}
	);
}
